const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'cosmoshub',
            client_id: '07-tendermint-1332',
            connection_id: 'connection-1065'
        },
        chain_2: {
            chain_name: 'kopi',
            client_id: '07-tendermint-4',
            connection_id: 'connection-8'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-1253',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-7',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'injective',
            client_id: '07-tendermint-278',
            connection_id: 'connection-281'
        },
        chain_2: {
            chain_name: 'kopi',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-376',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kopi',
            client_id: '07-tendermint-0',
            connection_id: 'connection-1'
        },
        chain_2: {
            chain_name: 'noble',
            client_id: '07-tendermint-140',
            connection_id: 'connection-135'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-9',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-122',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kopi',
            client_id: '07-tendermint-12',
            connection_id: 'connection-36'
        },
        chain_2: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-3422',
            connection_id: 'connection-10584'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-10',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-97998',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kopi',
            client_id: '07-tendermint-2',
            connection_id: 'connection-2'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-426',
            connection_id: 'connection-440'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-5',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-586',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
